// extracted by mini-css-extract-plugin
module.exports = {"accordion":"style-module__accordion___3-iXB","title":"style-module__title___3icQF","panel":"style-module__panel___2W_lo"};